import React from 'react'

interface Props {
  message: string
}

export const VenueMessage = ({ message }: Props) => {
  return <div className="text-foreground my-body-sm">{message}</div>
}
